<template>
    
    <div>
        <div class="pl-4" v-if="action != 'select'">

            <v-switch
            
            :label="$t('Bar chart')"
            @change="changeChartType()"
            ></v-switch>

        </div>
            
        <v-row>

            <v-col>

                <v-menu
                    ref="fromMenu"
                    v-model="fromMenu"
                    :close-on-content-click="false"
                    :return-value.sync="fromDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">

                        <v-text-field
                            v-model="fromDate"
                            :label="$t('From')"
                            readonly
                            v-on="on"
                            outlined
                            reactive
                            hide-details
                        ></v-text-field>

                    </template>

                    <v-date-picker 
                        v-model="fromDate" 
                        no-title 
                        @input="$refs.fromMenu.save(fromDate)"
                        @change="setTillDate()">
                    </v-date-picker>

                </v-menu>

            </v-col>

            <v-col>

                <v-menu
                    ref="toMenu"
                    v-model="toMenu"
                    :close-on-content-click="false"
                    :return-value.sync="tillDate"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                >
                    <template v-slot:activator="{ on }">
                    <v-text-field
                        v-model="tillDate"
                        :label="$t('Till')"
                        readonly
                        v-on="on"
                        outlined
                        reactive
                        hide-details
                    ></v-text-field>
                    </template>
                    <v-date-picker 
                        v-model="tillDate" 
                        no-title 
                        @input="$refs.toMenu.save(tillDate)"
                        @change="HideGraph()">
                    </v-date-picker>
                </v-menu>

            </v-col>


           

        </v-row>

        <div class="pb-2">
            
            <v-chip
                v-for="(tag, index) in selectedTags" :key="tag.id"
                class="ma-2"
                close
                :color="getColor(index)"
                text-color="white"
                @click:close="closeTag(index)"
            >

                {{ tag.name }}

            </v-chip>

            <v-btn text @click.stop="addTag()" v-if="selectedTags.length < 4">
                <v-icon left>mdi-plus</v-icon>
                {{ $t('Add') }}
            </v-btn>

        </div>

        
        <!-- {{chartData}}

        {{chartLabels}}

        {{chartDataSets}} -->
        
        <div v-if="showNoData == true">
             {{ $t('No data found') }}
        </div>

        <v-card outlined v-if="showGraph == false && selectedTags.length > 0" class="pa-8">

            <v-card-text  class="d-flex justify-center">

                <v-btn depressed color="primary" class="ma-auto" dark @click="loopTags()">
                    {{ $t('Load Graph') }}
                </v-btn>

            </v-card-text>
        
        </v-card>

        <div v-if="showGraph == true">


            <div v-if="ChartType == 'line'" class="pa-2">
                <LineChartComponent :chartData=data :options=options_line />
            </div>

             <div v-if="ChartType == 'bar'" class="pa-2">
                <BarChartComponent :chartData=data :options=options_bar />
            </div>
            
            <!-- <div class="pa-2">
                <v-card outlined tile v-for="selectedTag in loggingData" :key="selectedTag.id">

                    <div class="pa-2">
                        <b>{{selectedTag.name}}</b>
                    </div>

                    <v-card outlined tile v-for="logData in selectedTag.data" :key="logData.id">

                        <v-row align='center' class="pl-4">
                           
                            <v-col>{{logData.datetime}}</v-col>
                            <v-col><p class="text-xs-right">{{logData.value}}</p></v-col>
                            

                        </v-row>
                    </v-card>

                </v-card>
            </div> -->
        </div>

        
        

     
        <v-dialog
            v-model="app.popups.selectTag"
            width="500"
            >
                
                <ReportersComponent action="select" v-if="!selected.reporter || !selected.device"/>            
                <TagsComponent loggingOnly :hide_visuals="true" :device_id="selected.device.id" action="select" v-if="selected.reporter && selected.device"/>            

        </v-dialog>

        <v-dialog
            v-model="loadDialog"
            width="500"
            >
            <v-card>
              
                <v-card-title> {{ $t("Loading chart(s)") }} </v-card-title>
                
                <v-divider></v-divider>

                <v-card-text align="center" class="pt-4">

                    <v-progress-circular
                    :rotate="-90"
                    :size="100"
                    :width="15"
                    :value="percentageDone"
                    color="primary"
                    >
                    {{ percentageDone }}%
                    </v-progress-circular>
                
                </v-card-text>
                


            </v-card>

        </v-dialog>


    </div>

</template>

<script>

// import firebase from "firebase";

import { mapGetters } from "vuex";
import moment from "moment";

import ReportersComponent from '@/components/reporters/Reporters' ;
import TagsComponent from '@/components/devices/Tags' ;
import LineChartComponent from '@/components/charts/LineChart' ;
import BarChartComponent from '@/components/charts/BarChart' ;


export default {

    // extends: Line,

    // mounted () {
    //     this.renderChart(this.data, this.options)
    // },

    computed: {

        ...mapGetters({
            app: 'app/data',
            selected: 'app/selected',
            selectedTags: 'app/selectedTags',
        })

    },

    data () {
        return {
            fromDate: null,
            tillDate: null,
            toMenu: false,
            fromMenu: false,
            addPopup: false,
            loggingData: [],
            chartFromDate: null,
            chartTillDate: null,
            loadingFinished : false,
            tagCounter: null,
            nrOfTags : null,
            currentTag : null,
            dayCounter : null,
            nrOfdays : null,
            totalNrOfdaysCounter : null,
            totalNrOfdays : null,
            percentageDone : null,
            loadDialog: false,
            showGraph : false,
            showNoData : false,
            ChartType : null,
            
            chartData : [],
            chartLabels : [],
            chartDataSets :[],
            dragOptions : {
                animationDuration: 1000
            },
            
            data: {
                labels: null,
                datasets: null
            },
            options_line: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: false
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat:'D MMM YYYY HH:mm:ss', // <- HERE
                            displayFormats: {
                                'millisecond': 'HH:mm:ss',
                                'second': 'HH:mm:ss',
                                'minute': 'HH:mm',
                                'hour': 'D MMM HH:mm',
                                'day': 'D MMM',
                                'week': 'D MMM YYYY',
                                'month': 'MMM YYYY',
                                'quarter': '[Q]Q - YYYY',
                                'year': 'YYYY',
                            }
                        }
                    }],
                },
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: "x",
                            speed: 10,
                            threshold: 10
                        },
                        zoom: {
                            enabled: true,
                            drag: false,
                            mode: "xy",
                            limits: {
                                max: 10,
                                min: 0.5
                            }
                        }
                    }
                },
                


            },
            options_bar: {
                scales: {
                    yAxes: [{
                        ticks: {
                            beginAtZero: true
                        }
                    }],
                    xAxes: [{
                        type: 'time',
                        time: {
                            tooltipFormat:'D MMM YYYY HH:mm:ss', // <- HERE
                            displayFormats: {
                                'millisecond': 'HH:mm:ss',
                                'second': 'HH:mm:ss',
                                'minute': 'HH:mm',
                                'hour': 'D MMM HH:mm',
                                'day': 'D MMM',
                                'week': 'D MMM YYYY',
                                'month': 'MMM YYYY',
                                'quarter': '[Q]Q - YYYY',
                                'year': 'YYYY',
                            }
                        }
                    }],
                },
                responsive: true,
                maintainAspectRatio: false,
                plugins: {
                    zoom: {
                        pan: {
                            enabled: true,
                            mode: "x",
                            speed: 10,
                            threshold: 10
                        },
                        zoom: {
                            enabled: true,
                            drag: false,
                            mode: "xy",
                            limits: {
                                max: 10,
                                min: 0.5
                            }
                        }
                    }
                },
                


            }
        
        }
    },

    components: {
        ReportersComponent,
        TagsComponent,
        LineChartComponent,
        BarChartComponent,
    },

    methods: {

        addTag(){
            
            this.$store.commit("app/popUpSelectTag",true); //.('app/setSelected', data);
            this.HideGraph();
        },
        closeTag(index){
            this.HideGraph();
            this.selectedTags.splice(index, 1);
        },
        getColor(index){
            
            if(index == 0){
                return 'teal';
            }else if(index == 1){
                return 'orange';
            }else if(index == 2){
                return 'blue';
            }else if(index == 3){
                return 'purple';
            }else if(index == 4){
                return 'red';
            }

        },

        loopTags(){
           
            this.loggingData = [];
            this.chartData = [];

            let start_moment = moment(this.fromDate);
            let end_moment = moment(this.tillDate);

            this.nrOfTags = this.selectedTags.length;
            this.nrOfdays = Math.abs(start_moment.diff(end_moment, "days"));
            this.totalNrOfdays = this.nrOfTags * this.nrOfdays;

            this.tagCounter = 0;
            this.totalNrOfdaysCounter = 0;


            if(this.totalNrOfdays > 0){
                this.loadDialog = true;
                this.loopDays();
            }
            
        },

        loopDays(){          

            this.dayCounter = 0;
            this.currentTag = this.selectedTags[this.tagCounter];
            this.getLoggingData();

        },

        getLoggingData(){


            this.chartFromDate = moment(this.fromDate).add(this.dayCounter, "days");
            this.chartTillDate = moment(this.fromDate).add(this.dayCounter + 1, "days");
            
            this.percentageDone = Math.round((this.totalNrOfdaysCounter +1)/(this.totalNrOfdays) * 100);
            this.getFirebaseTagData(this.currentTag ,()=>{
                if(this.dayCounter == (this.nrOfdays - 1)){
                    
                    this.totalNrOfdaysCounter = this.totalNrOfdaysCounter + 1;
                    this.loadingFinished = true; 

                }else{
                    this.totalNrOfdaysCounter = this.totalNrOfdaysCounter + 1;
                    this.dayCounter = this.dayCounter +1;
                    this.getLoggingData();
                }
            });               

        },
        
        getFirebaseTagData(tag, callback){

         
            let timestamp_from = this.chartFromDate.unix(); 
            let timestamp_till = this.chartTillDate.unix(); 
            var logReference = tag.reporter.db.collection('logs');

            logReference
            .where("tag_id", "==", tag.id)
            .where("datetime", ">=", timestamp_from)
            .where("datetime", "<=", timestamp_till)
            .orderBy("datetime", "desc")
            .get()
            .then((querySnapshot) => {
                querySnapshot.forEach((logTag) => {
                    
                    let dataToStore = logTag.data();
                    dataToStore.id = logTag.id;
                    dataToStore.name = tag.name;
                    this.set_Tag(dataToStore);

                });

                callback();
            })
            .catch(function(error) {
                console.log("Error getting documents: ", error);
            });

        },

        set_Tag(loggingTag){

         
            
            // var log_data = {};

            // log_data.unix = loggingTag.datetime;
            // log_data.datetime = moment.unix(loggingTag.datetime).format("DD-MM-YYYY hh:mm:ss") ;
            // log_data.value = loggingTag.value;
            // log_data.id = loggingTag.id;


            // let index =  this.loggingData.findIndex(function( obj ) {
            //     return obj.tag_id === loggingTag.tag_id;
            // });

            // if(index !== -1){

            //     let data_index =  this.loggingData[index].data.findIndex(function( obj ) {
            //         return obj.id === loggingTag.id;
            //     });


            //     if(data_index !== -1){
            //         this.loggingData[index].data.splice(data_index, 1, log_data) ;
            //     }else{
            //         this.loggingData[index].data.push(log_data) ;
            //     }

            
            // }else{
                
            //     var newTag = {};
            //     newTag.tag_id = loggingTag.tag_id;
            //     newTag.name = loggingTag.name;
            //     newTag.data = [];
            //     newTag.data.push(log_data);

            //     this.loggingData.push(newTag) ;
            // }   
    
            // chart data
            let newData = {};
            newData.timestamp = loggingTag.datetime ;
            newData.label = moment.unix(loggingTag.datetime);
            newData.tag_id = loggingTag.tag_id ;
            newData.name = loggingTag.name;
            newData.value = loggingTag.value;

            this.chartData.push(newData);


        },


        setTillDate(){

            let newDate = moment(this.fromDate, "YYYY-MM-DD").add(1, 'day') ;

            if(!this.tillDate){
                this.tillDate = moment(newDate).format("YYYY-MM-DD") ;
            }else if(moment(this.fromDate).format() > moment(this.tillDate).format()){
                this.tillDate = moment(newDate).format("YYYY-MM-DD") ;
            }

            this.HideGraph();
            
        },

        HideGraph(){
            this.showGraph = false;
            this.showNoData = false;
        },

        changeChartType(){

    
            console.log(this.ChartType);

            if(this.ChartType == "line"){
                this.ChartType = "bar";
            }else if(this.ChartType == "bar"){
                this.ChartType = "line";
            }

            this.HideGraph();

        },loadFinished(){
            

            this.chartLabels = [];

            this.chartData.sort(function(a, b) {
                return a.timestamp - b.timestamp;
            });


            this.create_datasets(()=>{

                if(this.chartData.length >0){

                    this.chartData.forEach(loggingTag => {

                        // 
                        var label = moment.unix(loggingTag.timestamp);


                        // check if label already exists
                        let label_index =  this.chartLabels.findIndex(function( obj ) {
                            return obj === label;
                        });

                    

                        if(label_index !== -1){ // label does exist

                            let dataset_index =  this.chartDataSets.findIndex(function( obj ) {
                                return obj.tag_id === loggingTag.tag_id;
                            });

                            //if timestamp label does exist, update the data point for this dataset only
                        
                            for (let data_index = 0; data_index < this.nrOfTags; data_index++) {
                                if(dataset_index == data_index){
                                    this.chartDataSets[data_index].data.splice(label_index, 1, loggingTag.value); 
                                }
                                
                            }


                        }else{ // dataset does not exist
                            
                            // add new label timestamp
                            this.chartLabels.push(label);

                            let dataset_index =  this.chartDataSets.findIndex(function( obj ) {
                                return obj.tag_id === loggingTag.tag_id;
                            });

                            // check the datasets and add the current tag, and empty values for other tags
                            for (let data_index = 0; data_index < this.nrOfTags; data_index++) {
                                if(dataset_index == data_index){
                                    this.chartDataSets[data_index].data.push(loggingTag.value); 
                                }else{
                                    this.chartDataSets[data_index].data.push(null); 
                                }
                                
                            }
                        }
                        
                    });


                    this.data = {
                        labels: this.chartLabels,
                        datasets: this.chartDataSets
                    }

                    this.showGraph = true;

                }else{
                    console.log("NO DATA FOUND");
                    this.showNoData = true;
                }

                this.loadDialog = false;
        
            });

            
        },

        create_datasets(callback){

            this.chartDataSets = [];

            let index = 0;

            this.selectedTags.forEach(selectedTag => {
                
                if (this.ChartType == "line"){
                     let dataset = {};
                    dataset.label = selectedTag.name;
                    dataset.tag_id = selectedTag.id;
                    dataset.spanGaps = true;
                    dataset.backgroundColor = 'rgba(0, 0, 0, 0.0)';
                    dataset.borderColor = this.getColor(index);
                    dataset.pointRadius = 1;
                    dataset.borderWidth = 1;
                    dataset.data = [];

                    this.chartDataSets.push(dataset);

                }else if (this.ChartType == "bar"){


                    let dataset = {};
                    dataset.label = selectedTag.name;
                    dataset.tag_id = selectedTag.id;
                    dataset.spanGaps = true;
                    dataset.backgroundColor = this.getColor(index); //'rgba(0, 0, 0, 0.0)';
                    dataset.borderColor = this.getColor(index);
                    //dataset.pointRadius = 10;

                    dataset.barPercentage = 0.5;
                    dataset.barThickness = 10;
                    //dataset.maxBarThicknes = 8;
                    dataset.minBarLength= 2;
                    dataset.borderWidth = 10;
                    dataset.data = [];

                    this.chartDataSets.push(dataset);

                }
               
                index = index +1;
            });

            callback();
           
            
        }


        

    },
    watch: {


        loadingFinished: function () {
         
            if(this.loadingFinished){
                if(this.tagCounter == (this.nrOfTags - 1)){
                    
                
                      // finished 
                    this.loadFinished();

                  
                }else{
                    this.tagCounter = this.tagCounter +1;
                    this.loopDays();
                }
            }

            this.loadingFinished = false;
        }


        
    },

   

    created(){

        this.fromDate = moment().format("YYYY-MM-DD")
        this.tillDate = moment(this.fromDate).add(1, 'day').format("YYYY-MM-DD")
       
        moment.locale(this.app.locale);
        this.ChartType = "line";
       
    },

    

    

}

</script>